import { useMemo } from "react";

import { REACT_QUERY_STALE_TIME } from "src/constants";
import { useGetAccountingLineNewTenantQuery } from "src/graphql/generated/queries";
import { useCurrentAccount, useUuid } from "src/hooks";

/*
This hook should only be used when an account is selected
*/

export const useHasNewTenantHeadband = (): {
  isInitialLoading: boolean;
  hasNewTenantHeadband: boolean;
} => {
  const uuid = useUuid();
  const currentAccount = useCurrentAccount();

  const { data, isInitialLoading } = useGetAccountingLineNewTenantQuery(
    {
      uuid,
    },
    {
      enabled:
        currentAccount.__typename === "TenantAccount" && currentAccount.hasFutureLeaseEntryDate,
      staleTime: REACT_QUERY_STALE_TIME,
    }
  );

  const hasAccountingLines = useMemo(() => {
    return !!data?.account.accounting.lines.edges.map((e) => e.node).length;
  }, [data?.account.accounting.lines]);

  return {
    isInitialLoading,
    hasNewTenantHeadband:
      currentAccount.__typename === "TenantAccount" &&
      currentAccount.hasFutureLeaseEntryDate &&
      Boolean(data) &&
      !hasAccountingLines,
  };
};
